import { render, staticRenderFns } from "./orderRefund.vue?vue&type=template&id=1b3874ae&scoped=true"
import script from "./orderRefund.vue?vue&type=script&lang=js"
export * from "./orderRefund.vue?vue&type=script&lang=js"
import style0 from "./orderRefund.vue?vue&type=style&index=0&id=1b3874ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3874ae",
  null
  
)

export default component.exports